export default "__VITE_ASSET__48d1d977__"